import Link from "next/link";

import { Project } from "interfaces";

import { useFetchDataFile } from "modules/data-files/api";

import * as flowConfig from "flows/eta-estimator/config";
import { projectIsETAEstimator } from "flows/eta-estimator/interfaces";

const DataFileSummary = ({ project }: { project: Project }) => {
  const inputData = project.data_files[flowConfig.INPUT_DATA] as string;
  const { data: fileDetails } = useFetchDataFile(inputData);

  if (!projectIsETAEstimator(project)) {
    return null;
  }

  return (
    <div className="m-1">
      <p className="mb-2">
        <span className="font-semibold">Input Data:</span>{" "}
        <Link href={`/data-files/${inputData}`}>
          <a className="text-primary-main">{fileDetails?.name || inputData}</a>
        </Link>
      </p>
    </div>
  );
};

export default DataFileSummary;
